/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "../models";
import * as Mappers from "../models/deviceProtectionHistoryMappers";
import * as Parameters from "../models/parameters";
import { MicrosoftConsumerSecurityClientContext } from "../microsoftConsumerSecurityClientContext";

/** Class representing a DeviceProtectionHistory. */
export class DeviceProtectionHistory {
  private readonly client: MicrosoftConsumerSecurityClientContext;

  /**
   * Create a DeviceProtectionHistory.
   * @param {MicrosoftConsumerSecurityClientContext} client Reference to the service client.
   */
  constructor(client: MicrosoftConsumerSecurityClientContext) {
    this.client = client;
  }

  /**
   * Calls Consumer Security Device Protection History Manager to return the raw device protection
   * history.
   * @summary Get raw device protection history
   * @param deviceId
   * @param [options] The optional parameters
   * @returns Promise<Models.DeviceProtectionHistoryGetDeviceProtectionHistoryRawResponse>
   */
  getDeviceProtectionHistoryRaw(deviceId: string, options?: coreHttp.RequestOptionsBase): Promise<Models.DeviceProtectionHistoryGetDeviceProtectionHistoryRawResponse>;
  /**
   * @param deviceId
   * @param callback The callback
   */
  getDeviceProtectionHistoryRaw(deviceId: string, callback: coreHttp.ServiceCallback<Models.DeviceProtectionActivity[]>): void;
  /**
   * @param deviceId
   * @param options The optional parameters
   * @param callback The callback
   */
  getDeviceProtectionHistoryRaw(deviceId: string, options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.DeviceProtectionActivity[]>): void;
  getDeviceProtectionHistoryRaw(deviceId: string, options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.DeviceProtectionActivity[]>, callback?: coreHttp.ServiceCallback<Models.DeviceProtectionActivity[]>): Promise<Models.DeviceProtectionHistoryGetDeviceProtectionHistoryRawResponse> {
    return this.client.sendOperationRequest(
      {
        deviceId,
        options
      },
      getDeviceProtectionHistoryRawOperationSpec,
      callback) as Promise<Models.DeviceProtectionHistoryGetDeviceProtectionHistoryRawResponse>;
  }

  /**
   * Calls Consumer Security Device Protection History Manager to return the aggregated device
   * protection history.
   * @summary Get aggregated device protection history
   * @param deviceId
   * @param [options] The optional parameters
   * @returns Promise<Models.DeviceProtectionHistoryGetDeviceProtectionHistoryResponse>
   */
  getDeviceProtectionHistory(deviceId: string, options?: coreHttp.RequestOptionsBase): Promise<Models.DeviceProtectionHistoryGetDeviceProtectionHistoryResponse>;
  /**
   * @param deviceId
   * @param callback The callback
   */
  getDeviceProtectionHistory(deviceId: string, callback: coreHttp.ServiceCallback<Models.AggregatedDeviceProtectionHistory>): void;
  /**
   * @param deviceId
   * @param options The optional parameters
   * @param callback The callback
   */
  getDeviceProtectionHistory(deviceId: string, options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.AggregatedDeviceProtectionHistory>): void;
  getDeviceProtectionHistory(deviceId: string, options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.AggregatedDeviceProtectionHistory>, callback?: coreHttp.ServiceCallback<Models.AggregatedDeviceProtectionHistory>): Promise<Models.DeviceProtectionHistoryGetDeviceProtectionHistoryResponse> {
    return this.client.sendOperationRequest(
      {
        deviceId,
        options
      },
      getDeviceProtectionHistoryOperationSpec,
      callback) as Promise<Models.DeviceProtectionHistoryGetDeviceProtectionHistoryResponse>;
  }
}

// Operation Specifications
const serializer = new coreHttp.Serializer(Mappers);
const getDeviceProtectionHistoryRawOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/me/DeviceProtectionHistory/{deviceId}/raw",
  urlParameters: [
    Parameters.deviceId
  ],
  responses: {
    200: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DeviceProtectionActivity"
            }
          }
        }
      }
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const getDeviceProtectionHistoryOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/me/DeviceProtectionHistory/{deviceId}",
  urlParameters: [
    Parameters.deviceId
  ],
  responses: {
    200: {
      bodyMapper: Mappers.AggregatedDeviceProtectionHistory
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};
